import React from 'react';
import PropTypes from 'prop-types';
//Material-UI
import { Chip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { DataGrid, esES } from '@material-ui/data-grid';
//Context
import { useOrdProd } from './OrdProdContext';

const YellowChip = withStyles({ root: { backgroundColor: '#f8eab7', color: '#000' } })((props) => <Chip color="default" {...props} />);
const OrangeChip = withStyles({ root: { backgroundColor: '#fca63a', color: '#000' } })((props) => <Chip color="default" {...props} />);
const PurpleChip = withStyles({ root: { backgroundColor: '#E7D4FF', color: '#000' } })((props) => <Chip color="default" {...props} />);
const BlueChip = withStyles({ root: { backgroundColor: '#AEE8FC', color: '#000' } })((props) => <Chip color="default" {...props} />);
const RedChip = withStyles({ root: { backgroundColor: '#FCCACD', color: '#000' } })((props) => <Chip color="default" {...props} />);
const GreenChip = withStyles({ root: { backgroundColor: '#95FCDE', color: '#000' } })((props) => <Chip color="default" {...props} />);
const GrayChip = withStyles({ root: { backgroundColor: '#DBE0EA', color: '#000' } })((props) => <Chip color="default" {...props} />);
const PinkChip = withStyles({ root: { backgroundColor: '#FFAED2', color: '#000' } })((props) => <Chip color="default" {...props} />);
const PurpleNChip = withStyles({ root: { backgroundColor: '#EC666E', color: '#000' } })((props) => <Chip color="default" {...props} />);

function renderStatus(params) {
    switch (params.value) {
        case 1: return <YellowChip label="Pendiente" />;
        case 2: return <PurpleChip label="En Proceso" />;
        case 3: return <BlueChip label="Completada" />;
        case 4: return <RedChip label="Cerrada" />;
        case 5: return <RedChip label="Cancelada" />;
        case 6: return <PurpleChip label="Programada" />;
        case 7: return <GreenChip label="Entregada" />;
        case 8: return <PinkChip label="En almacen" />;
        case 9: return <OrangeChip label="Incompleta" />;
        case 10: return <GrayChip label="Almacenada" />;
        case 11: return <PurpleNChip label="Entregada" />;
        default: return <GrayChip label="Pendiente" />;
    }
}

const showCliente = process.env.REACT_APP_SHOW_CLIENTE_FIELD !== 'false';

const tableColumns = [
    { field: 'id', headerName: 'Código', flex: 0.7, minWidth: 100 },
    { field: 'estatus', headerName: 'Estatus', renderCell: renderStatus, align: 'center', width: 130 },
    ...(showCliente ? [{ field: 'cliente', headerName: 'Cliente', flex: 1, minWidth: 130 }] : []),
    { field: 'sku', headerName: 'SKU', flex: 0.6, minWidth: 60 },
    { field: 'skuNombre', headerName: 'Nombre Producto', flex: 1.5, minWidth: 150 },
    { field: 'cantidad', headerName: 'Total', align: 'center', flex: 0.7, minWidth: 70 },
    { field: 'producido', headerName: 'Producido', align: 'center', flex: 0.8, minWidth: 100 },
    { field: 'cantidadCalendario', headerName: 'En Calendario', align: 'center', flex: 0.9, minWidth: 110 },
    { field: 'resta', headerName: 'Restan', align: 'center', flex: 0.8, minWidth: 80 },
    { field: 'fecha', headerName: 'Fecha Creación', align: 'center', flex: 1, minWidth: 130 },
];

function TablaOrd({ rows }) {
    const { getTheOrder, selectionModel, setSelectionModel, setIsEdit, setIsDel } = useOrdProd();

    return (
        <DataGrid
            disableColumnFilter
            disableDensitySelector
            checkboxSelection
            headerHeight={64}
            columns={tableColumns}
            localeText={esES.props.MuiDataGrid.localeText}
            rows={rows}
            onSelectionModelChange={(newSelectionModel) => {
                if (newSelectionModel.length > 0) {
                    setIsEdit(newSelectionModel.length === 1);
                    setIsDel(true);
                    getTheOrder(newSelectionModel[0]);
                } else {
                    setIsDel(false);
                    setIsEdit(false);
                }
                setSelectionModel(newSelectionModel);
            }}
            selectionModel={selectionModel}
            hideFooterSelectedRowCount
        />
    );
}

TablaOrd.propTypes = {
    rows: PropTypes.array.isRequired,
};

export default TablaOrd;
